import React, { FC } from 'react';
import { useRouter } from 'next/router';
import useData from '@/data';
import { Icon } from '@/components/atomic/Icon';
import Button from '@/components/Button';
import { useGetUserContractFund } from '../hooks/useGetUserContractFund';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';
import { useGetFundDetails } from '@/modules/invest/subModules/fund/hooks/useGetFundDetails';

export const HeaderButton: FC = () => {
  const { push } = useRouter();
  const fundCode = useGetFundCodeFromQuery();
  const { hasUserContractFund } = useGetUserContractFund({ enabled: false });
  const { fundDetails } = useGetFundDetails(fundCode);

  const { setData, resetData } = useData('autoInvestSettings');

  const onButtonClickHandler = () => {
    resetData();
    const destinationInfo = {
      destination: 1,
      destinationCode: fundCode,
      destinationTitle: `صندوق ${fundDetails?.shortName}`,
      isRecommended: false,
    };
    setData({
      destinationInfo,
    });
    push('/auto-invest/create');
  };

  return (
    <Button
      analytics={['FUND_CLICK_AUTOINVEST_ACTIVATION']}
      className=" !pl-0 !font-demibold !text-link-filled-primary-enabled hover:!bg-transparent"
      classNames={{ childrenWrapper: '!flex !items-center ' }}
      variant="link"
      onClick={onButtonClickHandler}
    >
      {hasUserContractFund ? 'افزودن' : 'فعال‌سازی'}
      <Icon
        className="text-link-filled-primary-enabled"
        icon="chevron_left"
        size={16}
      />
    </Button>
  );
};
